import React, { useEffect } from 'react';
import './TermsPrivacy.css';

const Terms = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <section className="terms-privacy" id="terms">
      <div className="container-custom">
        <div className="terms-privacy-content">
          <h1>Terms & Conditions</h1>
          <p className="last-updated">Last updated: December 28, 2025</p>

          <h2>1. Agreement to Terms</h2>
          <p>These Terms & Conditions ("Terms") govern your access to and use of this website and any services provided by the company. By using the website you agree to these Terms.</p>

          <h2>2. Our Services</h2>
          <p>We provide information technology services, consulting, and hiring/career-related resources. Services and any project work are subject to separate written agreements which take precedence over these general Terms.</p>

          <h2>3. Use of Content</h2>
          <p>All content on this site (text, images, logos) is the property of the company or its licensors and may not be reused without permission.</p>

          <h2>4. User Responsibilities</h2>
          <p>When contacting us or using forms you agree to provide accurate information. You must not use the site for unlawful or abusive purposes.</p>

          <h2>5. Limitation of Liability</h2>
          <p>To the maximum extent permitted by law, the company is not liable for indirect, incidental or consequential damages arising from the use of the site or services.</p>

          <h2>6. Third-Party Links</h2>
          <p>The site may contain links to third-party websites. We are not responsible for the content or practices of those sites.</p>

          <h2>7. Changes</h2>
          <p>We may update these Terms at any time; changes take effect when posted. Continued use after updates constitutes acceptance.</p>

          <h2>8. Governing Law</h2>
          <p>These Terms are governed by the laws applicable to the company's registered jurisdiction.</p>

          <h2>9. Contact</h2>
          <p>Questions about these Terms can be sent to the contact address on the website.</p>
        </div>
      </div>
    </section>
  );
};

export default Terms;
